<template lang="pug">
  b-modal#addFunction(
  ref="addFunction"
  :title="$t('ui.combine.add_function')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-0
        DebounceInput(
          size="sm"
          ref="dataAdd_functionId"
          required
          alphaNum
          type="text"
          :dirty="$v.dataAdd_functionId.$dirty"
          :error="$v.dataAdd_functionId.$error"
          v-model.trim.lazy="$v.dataAdd_functionId.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_functionId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_functionId" :name="$t('ui.id')")
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_functionName.$dirty"
          :error="$v.dataAdd_functionName.$error"
          v-model.trim.lazy="$v.dataAdd_functionName.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_functionName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_functionName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_functionId: "",
      dataAdd_functionName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_functionId: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(30)
    },
    dataAdd_functionName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addFunctionUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.function,
          function_id: this.dataAdd_functionId,
          function_name: this.dataAdd_functionName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_functionId, this.dataAdd_functionName);
                  this.$refs.addFunction.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_function", this.feedback.status);
                  this.$refs.addFunction.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_functionId = "";
      this.dataAdd_functionName = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_functionId.$el.focus();
    }
  }
};
</script>
